import { Application } from '@enums/application.enums';
import type { PortfolioMediaUnlockedThrough } from '@models/portfolio-media-unlocked-through.interface';

export const MUSIC_PLAYER_CONST = {
  UNLOCK_THE_SONG_PLAY: 'Unlock the Song to Play',
  UNLOCK_ACCESS_THROUGH_OPTIONS_BELOW: 'Unlock access through options below',
  SUBSCRIBE: 'Subscribe',
  PAY: 'Pay',
  UNLOCK_WITH_NFT: 'Unlock with NFT',
  PURCHASE_MUSIC: 'PURCHASE SONG FOR',
  PURCHASE_MUSIC_VIA_SUBSCRIPTION: 'PURCHASE SONG VIA SUBSCRIPTION',
  PURCHASE_MUSIC_BY_NFT: 'PURCHASE SONG BY NFT',
  PURCHASE_COURSE: 'PURCHASE COURSE FOR',
  PURCHASE_COURSE_VIA_SUBSCRIPTION: 'PURCHASE COURSE VIA SUBSCRIPTION',
  PURCHASE_COURSE_BY_NFT: 'PURCHASE COURSE BY NFT',
  MUSIC: 'Music',
  RELEASED: 'Release Date',
  RELEASED_YEAR: 'Release Year',
  PURCHASE_PODCAST: 'PURCHASE PODCAST FOR',
  PURCHASE_PODCAST_VIA_SUBSCRIPTION: 'PURCHASE PODCAST VIA SUBSCRIPTION',
  PURCHASE_PODCAST_BY_NFT: 'PURCHASE PODCAST BY NFT',
  PURCHASE_VIDEO: 'PURCHASE VIDEO FOR',
  PURCHASE_VIDEO_VIA_SUBSCRIPTION: 'PURCHASE VIDEO VIA SUBSCRIPTION',
  PURCHASE_VIDEO_BY_NFT: 'PURCHASE VIDEO BY NFT',
  PURCHASE_ALBUM: 'PURCHASE ALBUM FOR',
  PURCHASE_ALBUM_VIA_SUBSCRIPTION: 'PURCHASE ALBUM VIA SUBSCRIPTION',
  PURCHASE_ALBUM_BY_NFT: 'PURCHASE ALBUM BY NFT',
  PURCHASE_SERIES: 'PURCHASE SERIES FOR',
  PURCHASE_SERIES_VIA_SUBSCRIPTION: 'PURCHASE SERIES VIA SUBSCRIPTION',
  PURCHASE_SERIES_BY_NFT: 'PURCHASE SERIES BY NFT',
  PURCHASE_COLLECTION: 'PURCHASE COLLECTION FOR',
  PURCHASE_COLLECTION_VIA_SUBSCRIPTION: 'PURCHASE COLLECTION VIA SUBSCRIPTION',
  PURCHASE_COLLECTION_BY_NFT: 'PURCHASE COLLECTION BY NFT',
  PURCHASE_ITEM: 'PURCHASE ITEM FOR',
  PURCHASE_ITEM_VIA_SUBSCRIPTION: 'PURCHASE ITEM VIA SUBSCRIPTION',
  PURCHASE_ITEM_BY_NFT: 'PURCHASE ITEM BY NFT',
  ALBUM: 'Album',
  SPACE_ALBUM: ' Album',
  SERIES: 'Series',
  SPACE_SERIES: ' Series',
  OR: 'or'
};

export const PURCHASE_MASTER_DATA_TEXT = {
  MUSIC: 'PURCHASE ENTIRE ALBUM',
  PODCAST: 'PURCHASE ENTIRE PODCAST SERIES',
  VIDEO: 'PURCHASE ENTIRE VIDEO SERIES'
};

export interface VideoModalInitialState {
  userSubscriptionList?: any[];
  pUserSubscriptionList?: any[];
  videoUrl?: string;
  posterUrl?: string;
  buttonColor?: string;
  closeButtonColor?: string;
  progressBarColor?: string;
  videoList?: VideoItem[];
  currentIndex?: number;
  albumTitle?: string;
  videoTitle?: string;
  dateOfRelease?: string;
  lock_through?: LockedThrough;
  isLocked?: boolean;
  userProfile?: any;
  portfolioType?: string;
  isMyProfile?: boolean;
  masterData?: any;
  portfolioCreatorUserName?: string;
  portfolioTypeId?: string;
  isIndividualPortfolio?: boolean;
  onPurchaseSubscription?: (video: any) => void;
  onPurchaseIndividual?: (video: any) => void;
  onPurchaseNft?: (video: any) => void;
  onPurchaseLoyaltyPoints?: (video: any) => void;
  hideShare?: boolean;
}

export interface VideoItem {
  videoUrl: string;
  posterUrl?: string;
  albumTitle?: string;
  videoTitle?: string;
  dateOfRelease?: string | number;
  isLocked?: boolean;
  lock_through?: LockedThrough;
  duration?: number;
  showTime?: boolean;
  canPreview?: boolean;
  download_url?: string;
  download_urls?: Record<string, string>;
  unlocked_through?: PortfolioMediaUnlockedThrough;
  pk?: string;
  sk?: string;
  description?: string;
  isMore?: boolean;
  isDownloadable?: boolean;
}

export interface LockedThrough {
  subscription?: Array<{ sk: string; pk: string; title?: string }>;
  individual?: {
    individual_price?: number | string;
    loyalty_points?: number;
  };
  nft?: string[];
}

export const COLORS = {
  DEFAULT_BUTTON_COLOR: '#00BFFF',
  DEFAULT_CLOSE_BUTTON_COLOR: '#00BFFF',
  DEFAULT_PROGRESS_BAR_COLOR: '#00b6ea'
};

export const getVideoType = (url: string): string => {
  if (url.includes('.m3u8')) return 'application/x-mpegURL';
  if (url.includes('.mp4')) return 'video/mp4';
  if (url.includes('.webm')) return 'video/webm';
  return 'video/mp4'; // default
};

export const MUSIC_VOLUME_STORAGE_KEY = 'musicPlayerVolume';

export const GET_VOLUME_FROM_STORAGE = (): number => {
  try {
    const savedVolume = localStorage.getItem(MUSIC_VOLUME_STORAGE_KEY);
    if (savedVolume !== null) {
      const volumeValue = parseFloat(savedVolume);
      if (
        !isNaN(volumeValue) &&
        volumeValue >= Application.ZERO &&
        volumeValue <= Application.ONE
      ) {
        return volumeValue;
      }
    } else return Application.ONE;
  } catch (error) {
    return Application.ONE;
  }
};

export const PURCHASE_TYPE = {
  INDIVIDUAL: 'individual',
  SUBSCRIPTION: 'subscription',
  NFT: 'nft'
};
